const bundleSection = document.querySelector('.product-form');
const addAllBtn = document.querySelector('#addAllToCart-btn');
let productVariantsToAdd = [];
addAllBtn.addEventListener('click', () => {
  const bundleVariants = bundleSection.querySelectorAll('.bundles__container .buy-buttons-row [name="id"]');
  productVariantsToAdd = Array.from(bundleVariants).map((variant) => variant.value);
  const productsToAdd = productVariantsToAdd.map((productId) => {
    return {
      'id': productId,
      'quantity': 1,
    }
  });
      
    let formData = {
       'items': [...productsToAdd]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(result => {
      const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
      const productTitle = document.querySelector('.product-title').textContent;
      notification.dataset.productTitle = productTitle;
      
      let notificationContainer = document.querySelector('.pageheader--sticky');
      if (!notificationContainer) {
        notificationContainer = document.querySelector('body');
      }
      notificationContainer.appendChild(notification);
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      }, 1000);
       document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
    })
    .catch((error) => {
      console.error('Error:', error);
    })
})